export default function(params) {
  const self = this;

  self.id = params['id'];
  self.type = 'Link';
  self.src = ko.observable(params['src']);
  self.$node = $(params['node']);
  self.loading = ko.observable(true);
  self.showPreview = ko.observable(false);

  self.fetchHeaders = _.memoize(function (src) {
    let url = Kadenze.Routes.temp_file_headers_path({url: src});

    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      dataAsJSON: false,
      timeout: 60000,
      loadingIndicator: {positionTop: 'absolute'}
    });
  });

  self.initLinkPreview = function () {
    if (self.src().indexOf('https://') === 0) {
      let request = self.fetchHeaders(self.src());

      request.done(function(data) {
        let headers = data.headers;
        if(headers['x-frame-options'] && (headers['x-frame-options'].toUpperCase() == 'DENY' || headers['x-frame-options'].toUpperCase() == 'SAMEORIGIN')) {
          self.showPreview(false);
        } else {
          self.showPreview(true);
        }
      });

      request.error(function(data) {
        self.showPreview(false);
      });

      request.always(function () {
        self.loading(false);
        params['parent'].refreshSlick();
      });
    } else {
      self.showPreview(false);
      self.loading(false);
      params['parent'].refreshSlick();
    }
  };

  self.init = () => {
    let el = self.$node.find('.js-preview-container')[0];
    ko.cleanNode(el);
    ko.applyBindings(self, el);
    self.initLinkPreview();
  };

  self.init();

  return self;
}

